// extracted by mini-css-extract-plugin
export var createdDate = "_ms-1";
export var divider = "_ms-2";
export var headerDivider = "_ms-3";
export var messagesCard = "_ms-0";
export var messagesContainer = "_ms-6";
export var messagesContainerWrapper = "_ms-4";
export var showLeftPanelButton = "_ms-8";
export var topButtons = "_ms-7";
export var withPadding = "_ms-5";